// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { makeEvent } from "~/lib/signals";
import ContentOverlay from "~/content.overlay";
import UserMarksContent from "~/usermarks-content";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { store } from "~/state/store";
import Notifications from "~/util/notifications";
import { CONFIG } from "~/config";

/**
 * @class Rucni mereni
 *
 * distacemeter-activated
 * distacemeter-deactivated
 */
export default class DistanceMeterContent extends ContentOverlay {
	constructor() {
		super();
		this._contentName = "distance-meter";
		this._dom = {
			container: node("div", { id: "distance-meter" })
		};

		this._buildCloseButton();
		this._loadPromise = null;
		this._distancemeter = null;
		this._lastDetailData = null;
	}

	activate() {
		var userMarks = Mapy.getComponent("userMarks");
		const { data, mark } = store.getState().detail;
		let item = null;

		// prenasime jeden bod z rucniho mereni
		if (userMarks.isActive() && (!this._distancemeter || (this._distancemeter && !this._distancemeter.getItems().length))) {
			item = userMarks.getOneItem();
		// pri aktivaci detailu pokazde preneseme jeho souradnice do mereni
		} else if (data) {
			const { source, id } = data;

			item = {
				source,
				id,
				coords: Scene.coordsFromWGS84(mark.lon, mark.lat),
			};
		}

		if (item && item.coords && this._lastDetailData != item) {
			this._add(item.coords);
			this._lastDetailData = item;
		}

		Mapy.getComponent("gpx").deactivate();

		if (this.isActive()) {
			while (Mapy.active[0] instanceof ContentOverlay && Mapy.active[0] !== this) {
				Mapy.active[0].deactivate();
			}
			this.show();

			return this;
		}
		else {
			var route = Mapy.getComponent("route");

			if (!route.isActive() && route.getRouteOverview()) {
				route.setState({});
			}

			var max = Mapy.active.length;

			for (var i = 0; i < max; i++) {
				if (Mapy.active[i] instanceof UserMarksContent) {
					Mapy.active[i].deactivate();
				}
			}
		}

		var thisSuper = super.activate();

		Mapy.SEO.set(_("distanceMeter.seo"));
		this._load().then(() => {
			this._distancemeter.activate();
			makeEvent("distacemeter-activated", this);
		}, () => {});

		return thisSuper;
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		if (this._distancemeter) {
			this._distancemeter.deactivate();
		}

		makeEvent("distacemeter-deactivated", this);

		return super.deactivate();
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);
		if (this._distancemeter) {
			this._distancemeter.show();
		}

		if (Mapy.getComponent("dimcurator") && this._likeData) {
			Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
		}

		return super.show();
	}

	hide() {
		if (this._distancemeter) {
			this._distancemeter.hide();
		}

		if (Mapy.getComponent("dimcurator") && this._likeData) {
			Mapy.getComponent("dimcurator").setState();
		}
	}

	setState(state) {
		var fromHistory = Mapy.getComponent("history").isFromHistory();

		if (!state.rm && !state.dmid && !state.likeData) {
			if (this._distancemeter && !this._distancemeter.readOnly) {
				this._distancemeter.setState(state || {}, fromHistory);
			}

			return Promise.resolve({});
		}

		return this._load().then(() => {
			console.log("distancemeter-content setState", state);
			this._distancemeter.setState(state || {}, fromHistory);

			if (fromHistory && Scene.isM3dActive()) {
				Mapy.getComponent("history").save(true);
			}
		}, () => {});
	}

	getState() {
		return this._distancemeter ? this._distancemeter.getState() : {};
	}

	// pokud tiskneme, tak jeste ulozime novou URL, protoze je jasne, ze jsme zmenili souradnice
	historyAfterState(state) {
		if ("p" in state && state.p == "3") {
			Mapy.getComponent("history").save(true);
		}
	}

	getMain() {
		return this._distancemeter;
	}

	getOneItem() {
		return this._distancemeter ? this._distancemeter.getOneItem() : null;
	}

	setBottomPanel() {
		if (this._distancemeter && this._distancemeter.getItems().length > 0) {
			var text = this._distancemeter.getBottomPanelText();
			if (text) {
				Mapy.getComponent("layout").setBottomPanel(node("h4", { className: "bp-distancemeter", innerHTML: text }));
			}
		} else {
			/* prohazovani stateswitche pro mala rozliseni */
			if (Mapy.Util.isSmallResolution() && Mapy.getComponent("layout").getWidth() != 1) {
				Mapy.getComponent("layout").setBottomPanel(node("p", { className: "bp-distancemeter empty-bar", innerHTML: _("distanceMeter.start", " ") }));
			}
		}
	}

	getContextMenuItems(e) {
		if (!this._distancemeter) { return []; }
		return this._distancemeter.getContextMenuItems(e);
	}

	_add(coords, index) {
		this._load().then(() => {
			this._distancemeter.add(coords, index);
			Mapy.getComponent("history").save();
		}, () => {});
	}

	/**
	 * Vraci objekt s nody, ktere se maji pouzit pro tisk
	 */
	getPrintNodes() {
		var div = node("div");
		div.appendChild(node("p", { innerHTML: "<strong>" + _("distanceMeter.title") + "</strong>" }));
		var userTitle = this._distancemeter.userTitle;
		if (userTitle) {
			div.appendChild(node("p", { textContent: userTitle, className: "user-title" }));
		}
		return {
			title: div,
			panel: this._distancemeter && this._distancemeter.getItems().length ? undefined : node("div")
		}
	}

	_load() {
		if (!this._loadPromise) {
			Mapy.getComponent("loader").start(true);
			this._loadPromise = import(
				/* webpackChunkName: "distancemeter" */
				'~/distancemeter/index.ts'
			);
			this._loadPromise.then(module => {
				module.initModule({ store, CONFIG, Scene });
				this._distancemeter = new module.default(this, Notifications);
				this._dom.container.appendChild(this._distancemeter.getContainer());
			}, () => {}).finally(() => {
				Mapy.getComponent("loader").end(true);
			});
		}

		return this._loadPromise;
	}
}
